import { render } from "./socialsComponent.vue?vue&type=template&id=40f79f22"
import script from "./socialsComponent.vue?vue&type=script&lang=js"
export * from "./socialsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__